"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKetteFilterPropertiesWithVerfahrweg = void 0;
function isKetteFilterPropertiesWithVerfahrweg(props) {
    return (props === null || props === void 0 ? void 0 : props.verfahrweg_mm) != null;
}
exports.isKetteFilterPropertiesWithVerfahrweg = isKetteFilterPropertiesWithVerfahrweg;
//# sourceMappingURL=KetteFilterProperties.js.map